import React, { useEffect, useState } from 'react';
import { Col, Row } from 'react-bootstrap';
import LoadingSpinner from '../../../components/LoadinSpinner';
import TitlePage from '../../../components/TitlePage';
import InputGeral from '../../../components/InputGeral/Index';
import { useNavigate, useParams } from 'react-router-dom';
import SubmitForm from '../../../components/SubmitForm';
import SelectDinamico from '../../../components/SelectDinamico';

import ConsultaAtitudeSegura from '../../../../lib/json/consultas/AtitudeSegura.json'
import ConsultaAtitudeSeguraDesviosMarcados from '../../../../lib/json/consultas/AtitudeSeguraDesviosMarcados.json'
import ConsultaAtitudeSeguraMelhoriasMarcadas from '../../../../lib/json/consultas/AtitudeSeguraMelhoriasMarcadas.json'
import ConsultaCentroCusto from '../../../../lib/json/consultas/CentroCustoSSMA.json'
import ConsultaFuncionario from '../../../../lib/json/consultas/FuncionariosSSMA.json'
import ConsultaEmpresasFilial from '../../../../lib/json/consultas/EmpresasFilial.json'
import ConsultaDescricaoAtividade from '../../../../lib/json/consultas/DescricaoAtividade.json'
import ConsultaLocalAtividade from '../../../../lib/json/consultas/LocalAtividade.json'
// import ConsultaEntreguePara from '../../../../lib/json/consultas/EntreguePara.json'
import ConsultaOpcoesDesvios from '../../../../lib/json/consultas/OpcoesDesvios.json'
import ConsultaConfiguracaoEmail from '../../../../lib/json/consultas/ConfiguracaoEmail.json'

import { format, parse } from 'date-fns';
import { ConsumoAPI_POST, ConsumoAPI_PUT } from '../../../../backend/ConsumoAPI';
import { converterObjetoParaArray, RetornaUsuarioLogado, SucessoMsg } from '../../../contents/VariaveisGlobais';
import SelectFixo from '../../../components/SelectFixo';
import RadioCheckGroup from '../../../components/RadioCheckGroup';
import { ConsultaAPI } from '../../../../backend/ConsultaAPI';
import DisparaEmail from '../../../../backend/DisparaEmail';

function FichaAtitudeSegura(){
    const navigate = useNavigate();
    
    const usuarioLogado = RetornaUsuarioLogado();
    const isFormVisual = window.location.href.includes('Visualizar');
    const { idAtitudeSegura } = useParams();
    const path = window.location.pathname

    const [carregar, setCarregar] = useState(false);
    const [inclusao, setInclusao] = useState(true);
    const [filialSelecionada, setFilialSelecionada] = useState(true);
    const [centroCustoSelecionado, setCentroCustoSelecionado] = useState(true);

    const menuUser = usuarioLogado.menu;
    const menuConvertido = converterObjetoParaArray(menuUser)
    const acesso = menuConvertido.toReversed().filter( (item) => path.includes(item.to.trim()) )[0].actions

    const optionsEmpresa =  [
                                {value: "NPE", text: "NPE"},
                                {value: "Terceiros", text: "Terceiros"}
                            ]

    const optionsTipoRegistro = [
                                    {value: "Desvio de SSMA", text: "Desvio de SSMA"},
                                    {value: "Quase Acidente", text: "Quase Acidente"},
                                    {value: "Participação e Consulta", text: "Participação e Consulta"}
                                ]
    const [disabledForm, setDisabledForm] = useState(isFormVisual);
    const [campoDataEvento, setCampoDataEvento] = useState();
    const [campoEmpresa, setCampoEmpresa] = useState({value: '', text: 'Digite'});
    const [campoTipoRegistro, setCampoTipoRegistro] = useState({value: '', text: 'Digite'});
    
    const [campoFilial, setCampoFilial] = useState({ value: '', text: 'Digite'});
    const [campoCentroCusto, setCampoCentroCusto] = useState({ value: '', label: 'Digite'});
    const [campoFuncionario, setCampoFuncionario] = useState({ value: '', label: 'Digite'});
    
    const [consultaCentroCusto, setConsultaCentroCusto] = useState('');
    const [consultaFuncionario, setConsultaFuncionario] = useState('');
    
    const [campoAcidenteInvestigado, setCampoAcidenteInvestigado] = useState('');
    const [campoRelatoQuaseAcidente, setCampoRelatoQuaseAcidente] = useState('');
    
    const [campoOutrosParticipacao, setCampoOutrosParticipacao] = useState('');
    const [campoDescricaoParticipacao, setCampoDescricaoParticipacao] = useState('');
    const [campoMelhoriasParticipacao, setCampoMelhoriasParticipacao] = useState([]);
    
    const [campoLocalDesvios, setCampoLocalDesvios] = useState()
    const [campoQtdPessoas, setCampoQtdPessoasDesvios] = useState()
    const [campoDescricaoAtividadeDesvios, setCampoDescricaoAtividadeDesvios] = useState()
    const [campoIdentificadoDesvios, setCampoIdentificadoDesvios] = useState()
    const [campoFuncionarioObservado, setCampoFuncionarioObservado] = useState()
    const [campoDesvios, setCampoDesvios] = useState([]);
    
    // const [optionsEntreguePara, setOptionsEntreguePara] = useState()
    const [optionsDesviosRender, setOptionsDesviosRender] = useState()
    const [optionsDesvios, setOptionsDesvios] = useState()

    const [campoDescricaoDesvios, setCampoDescricaoDesvios] = useState()

    const loadAtitudeSegura = async () => {
        var retConsulta = await ConsultaAPI( ConsultaAtitudeSegura.consulta + " WHERE DSMA.Id = '" + idAtitudeSegura + "'"  );
            
        if (retConsulta.data){
            const parsedDataHora = parse(retConsulta.data[0].DataHora, 'dd/MM/yyyy', new Date());
            const formatDataHora = format(parsedDataHora, 'yyyy-MM-dd')

            await changeCampoFilial(retConsulta.data[0].FilialId);
            await changeCentroCusto(retConsulta.data[0].FilialId, retConsulta.data[0].CentroCustoId);

            setCampoDataEvento( formatDataHora )
            setCampoEmpresa( { value: String(retConsulta.data[0].Empresa), text: retConsulta.data[0].Empresa } )
            setCampoTipoRegistro( { value: String(retConsulta.data[0].TipoRegistro), text: retConsulta.data[0].TipoRegistro } )
            setCampoFilial( { value: String(retConsulta.data[0].FilialId), label: retConsulta.data[0].FilialNome })
            setCampoCentroCusto( { value: retConsulta.data[0].CentroCustoId, label: retConsulta.data[0].Descricao })
            setCampoFuncionario( { value: String(retConsulta.data[0].FuncionariosId), label: retConsulta.data[0].FuncionariosId + ' - ' +retConsulta.data[0].FuncionariosNome })
            setCampoLocalDesvios( { value: String(retConsulta.data[0].LocalAtividadeId), label: retConsulta.data[0].LocalAtividadeNome })
            setCampoDescricaoAtividadeDesvios( { value: String(retConsulta.data[0].DescricaoAtividadeId), label: retConsulta.data[0].DescricaoAtividadeNome })
            setCampoQtdPessoasDesvios( retConsulta.data[0].QtdePessoas )
            setCampoIdentificadoDesvios( retConsulta.data[0].NaofoiIdentificadoDesvio )
            setCampoFuncionarioObservado( { value: String(retConsulta.data[0].FuncionariosNomedoObservadoId), label: retConsulta.data[0].FuncionariosNomedoObservadoId + ' - ' + retConsulta.data[0].NomedoObservado })
            setCampoDescricaoDesvios( retConsulta.data[0].DesvioDescricao )
            setCampoOutrosParticipacao( retConsulta.data[0].MelhoriaSSMAoutros )
            setCampoDescricaoParticipacao( retConsulta.data[0].ParticipacaoDescricao )

            setCampoRelatoQuaseAcidente( retConsulta.data[0].AcidenteDescricao )
            setCampoAcidenteInvestigado( { value: String(retConsulta.data[0].AcidenteInvestigado), label: retConsulta.data[0].AcidenteInvestigado } )
            
            var retConsultaDesvioMarcados = await ConsultaAPI( ConsultaAtitudeSeguraDesviosMarcados.consulta + " WHERE DesvioSSMAId = '" + idAtitudeSegura + "'"  );
            
            if (retConsultaDesvioMarcados.data){
                const Desvios = retConsultaDesvioMarcados.data.map( (item) => String(item.DesviosOpcoesId))
                setCampoDesvios(Desvios)
            }

            var retConsultaMelhoriasMarcadas = await ConsultaAPI( ConsultaAtitudeSeguraMelhoriasMarcadas.consulta + " WHERE DesvioSSMAId = '" + idAtitudeSegura + "'"  );
            
            if (retConsultaMelhoriasMarcadas.data){
                const Melhorias = retConsultaMelhoriasMarcadas.data.map( (item) => String(item.MelhoriasSSMAMarcadosId))
                setCampoMelhoriasParticipacao(Melhorias)
            }
        }
    }

    const handleCampoFilial = (e) =>{
        changeCampoFilial(e.value)
        setCampoFilial(e)
        setFilialSelecionada( !e.value )
    }

    const changeCampoFilial = (valor) =>{
        const parametroEmpresa = usuarioLogado.parametrosEmpresas.filter( (empresa) => empresa.empresaFilial.substr(0,4) === valor )
        let filtraCentroCusto = ''

        if (parametroEmpresa.length > 0 ){
            if (parametroEmpresa[0].centroCusto.length > 0){
                filtraCentroCusto += " AND CTT_CUSTO IN ('" + parametroEmpresa[0].centroCusto.join("','") + "')"
            }
        }

        const consultaCC = ConsultaCentroCusto.consulta + " WHERE CTT_FILIAL = '" + valor + "' " + filtraCentroCusto
        setConsultaCentroCusto(consultaCC)

        setCampoCentroCusto( { value: '', label: 'Digite'} );
    }

    const handleCampoCentroCusto = (e) =>{
        changeCentroCusto(campoFilial.value, e.value);
        setCampoCentroCusto(e)
        setCentroCustoSelecionado( !e.value )
    }

    const changeCentroCusto = (filial, valor) => {
        const consultaFunc = ConsultaFuncionario.consulta + " WHERE Filial = '" + filial + "' AND [Centro Custo] = '" + valor + "'"
        setConsultaFuncionario(consultaFunc)
        setCampoFuncionario( { value: '', label: 'Digite'} );
    }

    const handleSalvar = async() =>{
        let DesviosJSON = { Desvios: [] }
        
        DesviosJSON.Desvios.push( {label: "DataHora", type: "VarChar", value: campoDataEvento.trim() + 'T00:00:00' } )
        DesviosJSON.Desvios.push( {label: "Empresa", type: "VarChar", value: campoEmpresa.value } )
        DesviosJSON.Desvios.push( {label: "TipoRegistro", type: "VarChar", value: campoTipoRegistro.value } )
        DesviosJSON.Desvios.push( {label: "FilialId", type: "VarChar", value: campoFilial.value } )
        DesviosJSON.Desvios.push( {label: "CentroCustoId", type: "VarChar", value: campoCentroCusto.value } )
        DesviosJSON.Desvios.push( {label: "Descricao", type: "VarChar", value: campoCentroCusto.label.split(' - ')[1] } )
        DesviosJSON.Desvios.push( {label: "FuncionariosId", type: "Int", value: campoFuncionario.value } )
        DesviosJSON.Desvios.push( {label: "FuncionariosNome", type: "VarChar", value: campoFuncionario.label.split(' - ')[1] } )
        
        if (campoTipoRegistro.value === "Desvio de SSMA"){
            DesviosJSON.Desvios.push( {label: "QtdePessoas", type: "Int", value: campoQtdPessoas } )
            DesviosJSON.Desvios.push( {label: "LocalAtividadeId", type: "Int", value: campoLocalDesvios.value } )
            DesviosJSON.Desvios.push( {label: "DescricaoAtividadeId", type: "Int", value: campoDescricaoAtividadeDesvios.value } )
            DesviosJSON.Desvios.push( {label: "NaofoiIdentificadoDesvio", type: "Bit", value: eval(campoIdentificadoDesvios) } )
            DesviosJSON.Desvios.push( {label: "NaofoiIdentificadoDesvioOpcao", type: "VarChar", value: eval(campoIdentificadoDesvios) ? 'Sim' : 'Não' } )
            
            DesviosJSON.Desvios.push( {label: "DesvioDescricao", type: "VarChar", value: campoDescricaoDesvios } )
            
            if (!(eval(campoIdentificadoDesvios))){
                DesviosJSON.Desvios.push( {label: "FuncionariosNomedoObservadoId", type: "VarChar", value: campoFuncionarioObservado.value } )
                DesviosJSON.Desvios.push( {label: "NomedoObservado", type: "VarChar", value: campoFuncionarioObservado.label.split(' - ')[1] } )
            }else{
                DesviosJSON.DesvioSSMA = [... campoDesvios ]
            }
        }
        
        if (campoTipoRegistro.value === "Quase Acidente"){
            DesviosJSON.Desvios.push( {label: "AcidenteDescricao", type: "VarChar", value: campoRelatoQuaseAcidente } )
            DesviosJSON.Desvios.push( {label: "AcidenteInvestigado", type: "VarChar", value: campoAcidenteInvestigado.value } )
        }
        
        if (campoTipoRegistro.value === "Participação e Consulta"){
            DesviosJSON.Desvios.push( {label: "ParticipacaoDescricao", type: "VarChar", value: campoDescricaoParticipacao } )
            
            DesviosJSON.MelhoriasSSMA = [... campoMelhoriasParticipacao ]
            
            if (campoMelhoriasParticipacao.includes('6')){
                DesviosJSON.Desvios.push( {label: "MelhoriaSSMAoutros", type: "VarChar", value: campoOutrosParticipacao } )
            }
        }

        const valueJSON = JSON.stringify(DesviosJSON, null, 2)

        const rota = 'atitudeSegura' + (inclusao ? '' : '/' + idAtitudeSegura);

        const retConsumo = await (inclusao
            ? ConsumoAPI_POST(rota, valueJSON)
            : ConsumoAPI_PUT(rota, valueJSON));

        SucessoMsg(retConsumo.description);
        
        if (inclusao){
            const urlAcesso = window._env_?.REACT_APP_URL + '/ssma/AtitudeSegura/Visualizar/' + retConsumo.content
            
            var retUsuarios = await ConsultaAPI( ConsultaConfiguracaoEmail.consulta + " WHERE CentroCustoId = '" + campoCentroCusto.value + "'" );
    
            if (retUsuarios.data){
                retUsuarios.data.map((usuario) => {
                    DisparaEmail({
                        destinatario: usuario.Email,
                        assunto: 'Nova Observação de Risco de Trabalho - Tools System',
                        corpo: `<p>Prezado(a) ${usuario.Nome}</p></br>
                                <p>Esperamos que esta mensagem o encontre bem. Gostaríamos de informar sobre o novo cadastro da "Atitude Segura" incluído em nosso sistema. </p></br>
                                <h3>Detalhes da Inclusão:</h3>
                                <p><strong>ID:</strong> ${retConsumo.content}</p>
                                <p><strong>Data:</strong> ${campoDataEvento}</p>
                                <p><strong>Filial:</strong> ${campoFilial.label}</p>
                                <p><strong>Centro de Custo:</strong> ${campoCentroCusto.label}</p>
                                <p><strong>Observador:</strong> ${campoFuncionario.label}</p>
                                <a href='${urlAcesso}'>Mais detalhes clique no link</a></br></br>
                                <p><span>Agradecemos por seu comprometimento com a segurança, saúde e sustentabilidade!</span></p>`
                    });
                })
            }
        }

        if (acesso.length === 1){          
            navigate(window.location.pathname, { replace: true });  
            return false
        }
    }

    const handleDesvios = (value) => {
        if (campoDesvios.includes(value)) {
          setCampoDesvios(campoDesvios.filter((option) => option !== value));
        } else {
          setCampoDesvios([...campoDesvios, value]);
        }
    };

    const handleMelhoriasParticipacao = (value) => {
        if (campoMelhoriasParticipacao.includes(value)) {
          setCampoMelhoriasParticipacao(campoMelhoriasParticipacao.filter((option) => option !== value));
        } else {
          setCampoMelhoriasParticipacao([...campoMelhoriasParticipacao, value]);
        }
    };

    useEffect( () => {
        const fetchData = async () => {
            // var retConsulta = await ConsultaAPI( ConsultaEntreguePara.consulta );
            
            // if (retConsulta.data){
            //     const optionsEntregue = retConsulta.data.map( (item) => {
            //         return { value: String(item.Id), label: item.Id + ' - ' + item.Nome }
            //     })

            //     setOptionsEntreguePara(optionsEntregue)
            // }

            var retConsultaDesvios = await ConsultaAPI( ConsultaOpcoesDesvios.consulta + ' ORDER BY DSO.DesviosId ' );
            if (retConsultaDesvios.data){
                const uniqueEntries = new Set();

                const optionsDesviosCabecalhoAux = retConsultaDesvios.data.filter((item) => {
                    const { DesviosId, NomeDesvios } = item;

                    if (!uniqueEntries.has(DesviosId)) {
                        uniqueEntries.add(DesviosId);
                        return { DesviosId, NomeDesvios };
                    }

                    return false;
                });

                const optionsDesviosCabecalho = optionsDesviosCabecalhoAux.map( (item) => {
                    return { value: String(item.DesviosId), label: item.NomeDesvios }
                })

                const optionsDesviosDetail = retConsultaDesvios.data.map( (item) => {
                    return { value: String(item.Id), label: item.Id + ' - ' + item.Nome, indexador: String(item.DesviosId) }
                })
                
                setOptionsDesviosRender(optionsDesviosCabecalho)
                setOptionsDesvios(optionsDesviosDetail)
            }
        }

        fetchData()
        if (idAtitudeSegura){
            if (!disabledForm){
                setFilialSelecionada(false)
                setCentroCustoSelecionado(false)
            }
            
            setInclusao(false)
            loadAtitudeSegura();
        }
    }, []);

    return (
        <>
            <Row>
                <LoadingSpinner isLoading={carregar}/>
                <Col md="12" xs="12">
                    <TitlePage text="Atitude Segura"/>
                </Col>

                <Col md="3" xs="12">
                    <InputGeral
                        label="Data do Evento"
                        key="Cargo"
                        tipo='date'
                        disabled={!inclusao}
                        value={campoDataEvento}  // Use detail.cargo instead of campoEmail
                        onChange={(e) => setCampoDataEvento(e.target.value)}
                    />
                </Col>
                <Col md="4" xs="12">
                    <SelectFixo 
                        options={optionsEmpresa} 
                        value={campoEmpresa} 
                        selectedOptionValue={campoEmpresa} 
                        isLabel={true} 
                        label="Empresa" 
                        disabled={disabledForm}
                        onChange={(selectedOption) => setCampoEmpresa(selectedOption)}
                    />
                </Col>
                <Col md="5" xs="12">
                    <SelectFixo 
                        options={optionsTipoRegistro} 
                        value={campoTipoRegistro} 
                        selectedOptionValue={campoTipoRegistro} 
                        isLabel={true} 
                        label="Tipo de Registro" 
                        disabled={disabledForm}
                        onChange={(selectedOption) => setCampoTipoRegistro(selectedOption)}
                    />
                </Col>
                <Col md="3" xs="12">
                    <SelectDinamico 
                        label="Filial"
                        consulta={ConsultaEmpresasFilial.consulta + " WHERE '01' + LEFT(Filial, 2) IN ('" + usuarioLogado.empresasUsuario.join("','") + "') GROUP BY LEFT(Filial, 2), LEFT(Filial, 4), Empresa ORDER BY LEFT(Filial, 4)"}
                        tabela={ConsultaEmpresasFilial.tabelas}
                        cValue="Filial"
                        cText='Filial + " - " + item.Empresa'
                        isMultiplo={false}
                        campoValue={campoFilial}
                        value={campoFilial}
                        disabled={disabledForm}
                        showNoFilter={true}
                        onchange={(e) => handleCampoFilial(e)}
                    />
                </Col>
                <Col md="4" xs="12">
                    <SelectDinamico 
                        label="Centro de Custo"
                        consulta={consultaCentroCusto}
                        tabela={ConsultaCentroCusto.tabelas}
                        cValue="CTT_CUSTO"
                        cText='CTT_CUSTO + " - " + item.CTT_DESC01'
                        isMultiplo={false}
                        disabled={filialSelecionada}
                        campoValue={campoCentroCusto}
                        value={campoCentroCusto}
                        showNoFilter={true}
                        onchange={(e) => handleCampoCentroCusto(e)}
                    />
                </Col>
                <Col md="5" xs="12">
                    <SelectDinamico 
                        label="Observador"
                        consulta={consultaFuncionario}
                        tabela={ConsultaFuncionario.tabelas}
                        cValue="Matricula"
                        cText='Matricula + " - " + item["Nome complet"]'
                        isMultiplo={false}
                        disabled={centroCustoSelecionado}
                        campoValue={campoFuncionario}
                        value={campoFuncionario}
                        showNoFilter={true}
                        onchange={(e) => setCampoFuncionario(e)}
                    />
                </Col>
            </Row>

            { campoTipoRegistro.value === "Quase Acidente" && (
                <Row>
                    <Col md="12" xs="12">
                        <InputGeral
                            label="Relate aqui um quase acidente que você tenha presenciado e tratado junto a sua liderança e a equipe de SSMA da sua frente de trabalho:"
                            key="textArea"
                            tipo='textArea'
                            disabled={disabledForm}
                            value={campoRelatoQuaseAcidente}  // Use detail.cargo instead of campoEmail
                            onChange={(e) => setCampoRelatoQuaseAcidente(e.target.value)}
                        />
                    </Col>
                    <Col md="3" xs="12">
                        <RadioCheckGroup
                            type="radio"
                            label="Quase acidente Investigado ?"
                            disabled={disabledForm}
                            selectedOption={campoAcidenteInvestigado}  // Use detail.cargo instead of campoEmail
                            onChange={(selectedValue) => setCampoAcidenteInvestigado(selectedValue)}
                            options={ [ { value: 'Sim', label: 'Sim' }, 
                                        { value: 'Não', label: 'Não' }
                                    ] }
                        />
                    </Col> 
                </Row>
            )}
            
            { campoTipoRegistro.value === "Participação e Consulta" && (
                <Row>
                    <Col md="12" xs="12">
                        <RadioCheckGroup
                            type="checkbox"
                            label="Deixe aqui a sua participação: o que podemos fazer para melhorar o setor de SSMA"
                            selectedOption={campoMelhoriasParticipacao}  // Use detail.cargo instead of campoEmail
                            onChange={handleMelhoriasParticipacao}
                            disabled={disabledForm}
                            options={ [ 
                                        { value: '1', label: 'Investimento em treinamentos na equipe de SSMA' }, 
                                        { value: '2', label: 'Realizando mais inspeção de segurança na área de trabalho' }, 
                                        { value: '3', label: 'Dando retorno das reclamações e sugestão realizada pelos colaboradores da NPE' }, 
                                        { value: '4', label: 'Criando pesquisas de satisfação do setor de SSMA' }, 
                                        { value: '5', label: 'Criando pesquisas de campanhas de SSMA' }, 
                                        { value: '6', label: 'Outros' }
                                    ] }
                        />

                        { campoMelhoriasParticipacao && campoMelhoriasParticipacao.includes('6') && (
                            <InputGeral
                            label="Outros:"
                            tipo='text'
                            disabled={disabledForm}
                            value={campoOutrosParticipacao}  // Use detail.cargo instead of campoEmail
                            onChange={(e) => setCampoOutrosParticipacao(e.target.value)}
                            />
                        )}
                    </Col> 
                    <Col md="12" xs="12">
                        <InputGeral
                            label="Descrição"
                            key="textArea"
                            tipo='textArea'
                            disabled={disabledForm}
                            value={campoDescricaoParticipacao}  // Use detail.cargo instead of campoEmail
                            onChange={(e) => setCampoDescricaoParticipacao(e.target.value)}
                        />
                    </Col>
                </Row>
            )}

            { campoTipoRegistro.value === "Desvio de SSMA" && (
                <>
                    <Row>
                        <Col md="5" xs="12">
                            <SelectDinamico 
                                label="Local da Atividade"
                                consulta={ConsultaLocalAtividade.consulta}
                                tabela={ConsultaLocalAtividade.tabelas}
                                cValue="Id"
                                cText='Id + " - " + item.Nome'
                                isMultiplo={false}
                                disabled={disabledForm}
                                value={campoLocalDesvios}
                                campoValue={campoLocalDesvios}
                                showNoFilter={true}
                                onchange={(e) => setCampoLocalDesvios(e)}
                            />      
                        </Col>
                        <Col md="5" xs="12">
                            <SelectDinamico 
                                label="Descrição da Atividade"
                                consulta={ConsultaDescricaoAtividade.consulta}
                                tabela={ConsultaDescricaoAtividade.tabelas}
                                cValue="Id"
                                cText='Id + " - " + item.Nome'
                                isMultiplo={false}
                                disabled={disabledForm}
                                value={campoDescricaoAtividadeDesvios}
                                campoValue={campoDescricaoAtividadeDesvios}
                                showNoFilter={true}
                                onchange={(e) => setCampoDescricaoAtividadeDesvios(e)}
                            />
                        </Col>
                        <Col md="2" xs="12">
                            <InputGeral
                                label="Qtd Pessoas"
                                tipo='numero'
                                disabled={disabledForm}
                                value={campoQtdPessoas}  // Use detail.cargo instead of campoEmail
                                onChange={(e) => setCampoQtdPessoasDesvios(e.target.value)}
                            />
                        </Col>
                    </Row>

                    <Row>
                        <Col md="3" xs="12">
                            <RadioCheckGroup
                                type="radio"
                                label="Foi Identificado Desvio"
                                disabled={disabledForm}
                                selectedOption={campoIdentificadoDesvios}  // Use detail.cargo instead of campoEmail
                                onChange={(selectedValue) => setCampoIdentificadoDesvios(selectedValue)}
                                options={ [ { value: 'true', label: 'Sim' }, 
                                            { value: 'false', label: 'Não' }
                                        ] }
                            />
                        </Col> 

                        { campoIdentificadoDesvios === "false" && (
                            <Col md="5" xs="12">
                                <SelectDinamico 
                                    label="Observado"
                                    consulta={consultaFuncionario}
                                    tabela={ConsultaFuncionario.tabelas}
                                    cValue="Matricula"
                                    cText='Matricula + " - " + item["Nome complet"]'
                                    isMultiplo={false}
                                    campoValue={campoFuncionarioObservado}
                                    value={campoFuncionarioObservado}
                                    disabled={centroCustoSelecionado}
                                    showNoFilter={true}
                                    onchange={(e) => setCampoFuncionarioObservado(e)}
                                />
                            </Col>
                        )}
                    </Row>

                    { campoIdentificadoDesvios === "true" && Array.isArray(optionsDesviosRender) &&  (
                        optionsDesviosRender.map( (item) => {
                            return (
                                <Row>
                                    <Col md="12" xs="12">
                                        <RadioCheckGroup
                                            type="checkbox"
                                            label={item.label}
                                            selectedOption={campoDesvios}  // Use detail.cargo instead of campoEmail
                                            onChange={handleDesvios}
                                            disabled={disabledForm}
                                            options={optionsDesvios.filter( (options) => options.indexador === item.value )}
                                        />
                                    </Col>
                                </Row>
                            )
                        })
                    )}
                    <Row>
                        <Col md="12" xs="12">
                            <InputGeral
                                label="Descrição"
                                key="textArea"
                                tipo='textArea'
                                disabled={disabledForm}
                                value={campoDescricaoDesvios}  // Use detail.cargo instead of campoEmail
                                onChange={(e) => setCampoDescricaoDesvios(e.target.value)}
                            />
                        </Col>
                    </Row>
                </>
            )}

            <SubmitForm onSave={disabledForm ? null : handleSalvar} onCancel={disabledForm ? null : "handleCancelar"} onVoltar={disabledForm ? "handleCancelar" : null } ></SubmitForm>
        
        </>
    );
};

export default FichaAtitudeSegura;
